import type { PopupName, PopupStateData } from 'reactApp/modules/popup/popup.types';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getPopupState = (state: RootState) => state.popup;
export const getOpenPopups = createSelector(getPopupState, (popup): PopupStateData[] => popup.sequence);
export const isOpenPopups = createSelector(getPopupState, (popup): boolean => popup.sequence?.length > 0);
export const isOpenPopup = createSelector(
    [getPopupState, (_state: RootState, popupName: PopupName) => popupName],
    (popup, popupName): boolean => popup.sequence.some((item) => item.name === popupName)
);
